import React from 'react'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import QuoteForm from '../../components/pages/Quote/QuoteForm'

const Quote = () => {
  return (
    <div>
        <Navbar/>
        <QuoteForm/>
        <Footer/>
    </div>
  )
}

export default Quote